import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './useAuth';

export default function ProtectedRoute() {
  const { user, loading, isCustomer } = useAuth();

  // Pendant qu'on vérifie l'auth, on affiche un loader
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-950 text-white">
        <p className="text-neutral-400">Chargement...</p>
      </div>
    );
  }

  // Pas connecté → redirige vers login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Client (a un customer_profile) → l'app staff lui est interdite.
  // On redirige vers son espace /mon-compte. Cas couvert ici plutôt
  // que dans chaque page pour avoir une seule porte d'entrée.
  if (isCustomer) {
    return <Navigate to="/mon-compte" replace />;
  }

  // Connecté + non-client → affiche les routes protégées
  return <Outlet />;
}
